import React__default, { memo } from 'react';
import { map, get } from 'lodash-es';
import PropTypes from 'prop-types';
import { StyledTableCell } from './Table.styles.js';
function CRMTableCell(_ref) {
  let {
    rowData,
    headers,
    rows,
    rowIndex,
    lastFixedItem,
    calculateLeftDistance,
    verticalAlign
  } = _ref;
  const renderChild = headerItem => {
    const Child = rowData.find(cellItem => cellItem.props.slot === headerItem.id);
    if (Child) {
      return Child;
    }
    return null;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, map(headers, (headerItem, rIndex) => {
    if (!get(headerItem, 'show', false)) {
      return null;
    }
    const cellWidth = headerItem.width;
    const leftDistance = calculateLeftDistance(rIndex, headers);
    return /*#__PURE__*/React__default.createElement(StyledTableCell, {
      isFixed: headerItem.fixed,
      title: headerItem.title,
      lastFixedItem: lastFixedItem,
      leftDistance: leftDistance,
      key: rIndex,
      index: rIndex,
      rowIndex: rowIndex,
      rows: rows,
      cellWidth: cellWidth,
      maxWidth: headerItem === null || headerItem === void 0 ? void 0 : headerItem.maxWidth,
      verticalAlign: verticalAlign,
      align: get(headerItem, 'centerText', false) ? 'center' : 'left'
    }, renderChild(headerItem));
  }));
}
CRMTableCell.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.shape({})),
  headers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rows: PropTypes.number,
  rowIndex: PropTypes.number.isRequired,
  lastFixedItem: PropTypes.number,
  calculateLeftDistance: PropTypes.func,
  verticalAlign: PropTypes.string
};
CRMTableCell.defaultProps = {
  rowData: null,
  lastFixedItem: null,
  rows: 40,
  verticalAlign: null,
  calculateLeftDistance: () => 0
};
var CRMTableCell$1 = /*#__PURE__*/memo(CRMTableCell);
export { CRMTableCell$1 as default };